module.exports = __webpack_public_path__ + "img/group25@2x-ko.e5e99654.png";